$(document).ready(function(){
	
	var successSlider;
	const $sliderdiv = $('.success-slider');

	if ($sliderdiv && typeof $sliderdiv.slick == 'function') {

		successSlider = $sliderdiv.slick({
			dots: true,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			autoplaySpeed: 7000,
			centerMode: false,
			variableWidth: false,
			prevArrow: '<button type="button" class="slick-prev">prev</button>',
			nextArrow: '<button type="button" class="slick-next">next</button>'
		});

		$sliderdiv.find('.slick-list').show();

		$sliderdiv.on("swipe", function(event, slick, direction) {
			successSlider.slick('slickSetOption', {
				'autoplay': false
			}, true);
		});

		$(".slick-prev, .slick-next, .slick-dots button").on("click", function() {
			successSlider.slick('slickSetOption', {
				'autoplay': false
			}, true);
		});

		successSlider.on('init', function (event, slick) {
		});
	}

});